import { Controller } from "@hotwired/stimulus"
import ClipboardJS from "clipboard"
import { Tooltip } from "bootstrap"

const TOOLTIP_DURATION_MS = 1000

export default class extends Controller {
  connect() {
    this.clipboard = new ClipboardJS(this.element)
    this.clipboard.on("success", () => this.flashTooltip("Copied!"))
    this.clipboard.on("error", () => this.flashTooltip("Failed!"))
  }

  disconnect() {
    this.clipboard.destroy()
  }

  flashTooltip(message) {
    const tooltip = new Tooltip(this.element, { placement: "top", title: message, trigger: "manual" })
    tooltip.show()
    setTimeout(() => tooltip.dispose(), TOOLTIP_DURATION_MS)
  }
}
